import { createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import { PROXY_KEY, FETCH_BY_KEYWORD, FETCH_BY_ID, optionsFetchAPI } from '../apiConfig.js';
import { formatAsBook } from '../utils.js';


// Thunk för att söka böcker
async function fetchBooksHandler(searchParams, thunkAPI) {
  try {
    const query = new URLSearchParams(searchParams);
    const response = await fetch(FETCH_BY_KEYWORD + query, optionsFetchAPI);

    if (!response.ok) throw new Error("Network response was not ok");
    const data = await response.json();
    return data; // detta blir payload i fulfilled
  } 
  catch (error) {
    return thunkAPI.rejectWithValue(error.message); // blir payload i rejected
  }
};
//sök på id 
async function fetchBookIdHandler(searchParams,thunkAPI) {
    console.log("i fetchBookIdHandler, searchParams:", searchParams);
  try{
    const query = new URLSearchParams(searchParams);
    const response = await fetch(FETCH_BY_ID + query, optionsFetchAPI);
    if (!response.ok) throw new Error("Network response was not ok");
    
    const data = await response.json();
    return data; // detta blir payload i fulfilled
  }
  catch(error){
    return thunkAPI.rejectWithValue(error.message); // blir payload i rejected
  }
}

const searchBookSlice = createSlice({
  name: 'searchBook',
  initialState: {   
    searchResults: [],
    searchResultId: null,
    requestId: undefined,
    statusId: 'idle',
    status: 'idle',
    error: null,
    errorId: null,
  },
  reducers: {
    clearIdResults(state){
      state.searchResultId = null;
      state.statusId = 'idle';
      state.errorId = null;
    },
    clearSearch(state){
      state.searchResults = [];
      state.searchResultId = null;
      state.status = 'idle';
      state.statusId = 'idle';
      state.error = null;
      state.errorId = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBooksByKeyword.pending, (state, action) => {
        state.requestId = action.meta.requestId;  // save the latest requestId, requestId is generated by createAsyncThunk
        state.status = "pending";
        state.error = null;
      })
      .addCase(fetchBooksByKeyword.fulfilled, (state, action) => {
        if (state.requestId !== action.meta.requestId)  // ignore if not the latest request aka race conditions
          return;
        state.status = "fulfilled";
        state.searchResults = action.payload;
      })
      .addCase(fetchBooksByKeyword.rejected, (state, action) => {
        state.status = "rejected";
        state.error = action.payload;
      })
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      .addCase(fetchBookById.pending, (state, action) => {
        state.requestId = action.meta.requestId;  // save the latest requestId, requestId is generated by createAsyncThunk
        state.statusId = "pending";
        state.errorId = null;
      })
      .addCase(fetchBookById.fulfilled, (state, action) => {
        if (state.requestId !== action.meta.requestId)  // ignore if not the latest request aka race conditions
          return;
        state.statusId = "fulfilled";
        state.searchResultId = formatAsBook(action.payload);
      })
      .addCase(fetchBookById.rejected, (state, action) => {
        state.statusId = "rejected";
        state.errorId = action.payload;
      });
  },
});
export const fetchBooksByKeyword = createAsyncThunk("searchBook/byKeyword",fetchBooksHandler);
export const fetchBookById = createAsyncThunk("searchBook/byId",fetchBookIdHandler);
export const { clearIdResults, clearSearch } = searchBookSlice.actions;
export default searchBookSlice.reducer;